<!-- DIALOG-BACKUP -->
<div class="master-modal" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <!-- Modal-Header -->
        <div class="modal-header">
          <h4 class="modal-title"> Reason</h4>
          <div class="modal_close_btn">
            <span (click)="closeDialog()" class="modal-close"><i class="material-icons">close</i></span>
          </div>
        </div>
        <form>
          <!-- Modal content-->
          <perfect-scrollbar class="modal-body-scrollbar">
            <div mat-dialog-content>
              <!-- Modal-Body -->
              <div class="modal-body">
                  <p>{{data.rejection_reason}}</p>
              </div>
            </div>
          </perfect-scrollbar>
          <!-- Modal-Footer -->
          <!-- <div class="modal-footer">
            <div mat-dialog-actions class="modal_footer">
              <button type="button" mat-button (click)="closeDialog()" class="modal-cancel-btn modal-footer-btn">
                <span>Cancel</span>
              </button>
              <button type="submit" mat-button class="modal-save-btn global-btn modal-footer-btn" >
                <span>Send enquiry </span>
              </button>
            </div>
          </div> -->
        </form>
      </div>
    </div>
  </div>
